import type {
  NewsFetchOptions,
  NewsListParams,
} from '@features/news/api/newsApi.types'
import { mapNewsDto, mapNewsListDto } from '@features/news/api/newsMapper'
import type { News, NewsListResult } from '@features/news/types'
import type { NewsDto, NewsListDto } from '@shared/api/news.dto'
import { useNuxtApi } from '@shared/nuxt/useNuxtApi'

export const newsApi = {
  getList(
    params: NewsListParams,
    options?: NewsFetchOptions<NewsListDto, NewsListResult>,
  ) {
    return useNuxtApi<NewsListDto, NewsListResult>('/api/news/list', {
      ...options,
      query: params,
      transform: mapNewsListDto,
    })
  },

  getBySlug(slug: string, options?: NewsFetchOptions<NewsDto, News>) {
    return useNuxtApi<NewsDto, News>(`/api/news/${slug}`, {
      ...options,
      transform: mapNewsDto,
    })
  },
}
